import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ShowinDirective } from '../../../directives/animations/showin.directive';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';
import { Logo } from '../../common/logo/logo';

@Component({
  selector: 'section[app-about-hero-section]',
  imports: [
    NgOptimizedImage,
    Logo,
    ShowinDirective,
    ShowleftDirective,
  ],
  templateUrl: './about-hero-section.html',
  styleUrl: './about-hero-section.scss',
})
export class AboutHeroSection {
  get appname(): string {
    return environment.appname;
  }
}
